var React = require('react');

function QuoteInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.6667 9.3335L12 17.3335H14.6667V24.0002H8V17.3335L10.6667 9.3335H14.6667Z","fill":"#D9D9E2","key":0}),React.createElement("path",{"opacity":"0.3","fillRule":"evenodd","clipRule":"evenodd","d":"M25.3327 9.3335L22.666 17.3335H25.3327V24.0002H18.666V17.3335L21.3327 9.3335H25.3327Z","fill":"#D9D9E2","key":1})]);
}

QuoteInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = QuoteInline;

QuoteInline.default = QuoteInline;
